import { desktop, modifier, tablet } from '@styles/mixins'
import { colors, grid } from '@styles/vars'
import styled, { css } from 'styled-components'

type BoxProps = { narrow?: boolean, hide?: boolean, background?: string }
export const Box = styled.div<BoxProps>`
    padding: 30px;
    background: ${props => props.background || "rgba(255, 255, 255, 0.8)"};
    border-radius: 10px;
    border: 1px solid ${colors.border};

    ${tablet(css<BoxProps>`
        padding: ${props => props.narrow ? "30px" : "60px"};
    `)}

    ${modifier("hide", css`
        padding: 0;
        border: 0;
        background: transparent;

        ${tablet(css`
            padding: 0;
        `)}
    `)}
`


export const Container = styled.div`
    width: 100%;
    padding: 0 ${grid.margins.phone};

    ${tablet(css`
        padding: 0 ${grid.margins.tablet};
    `)}

    ${desktop(css`
        padding: 0 ${grid.margins.desktop};
        margin: 0 auto;
    `)}
`

export const NarrowContainer = styled.div`
    max-width: 800px;
    width: 100%;
    padding: 0 ${grid.margins.phone};

    ${tablet(css`
        padding: 0 ${grid.margins.tablet};
    `)}

    ${desktop(css`
        padding: 0 ${grid.margins.desktop};
        margin: 0 auto;
    `)}
`

export const FullWidthContainer = styled.div`
    width: 100vw;
    margin: 0 calc((100% - 100vw) / 2);
`

export const Background = styled.div<{ color?: string, image?: string }>`
    width: 100%;
    height: 100%;
    background-color: ${props => props.color || "inherit"};
    background-image: ${props => `url(${props.image})` || "none"};
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
`